<template>
  <div class="container-social-media">
    <div class="header-social-media">
      <span class="header-social-media-title"> Análise de Redes Sociais</span>
      <div class="header-social-media-content-buttons">
        <div class="header-social-media-content-select">
          <multiselect
            id="ajax"
            v-model="term"
            label="value"
            track-by="id"
            placeholder="Selecione um ou mais termos"
            open-direction="bottom"
            :options="termsSelect"
            :searchable="true"
            :loading="isLoadingSocialValues"
            @search-change="handleSocialValues"
            :noOptions="'Sem termos cadastrados'"
            :showNoOptions="true"
          >
            <template #noOptions>
              <span>Sem termos cadastrados</span>
            </template>
          </multiselect>

          <LoadingButton :loading="isSearching" :style="styleLoadingButton" @click="handleSearch">
            Consultar
          </LoadingButton>
          <Button
            v-if="$page.props.auth.user.email === 'super@smart-destination.com'"
            icon="pi pi-cog"
            label="Configurar filtros"
            style="
              white-space: nowrap;
              height: 40px;
              min-width: 202px;
              background: #001a28;
              color: #fff;
            "
            @click="handleFilters"
          />
        </div>
        <h3>Fontes: Instagram, Tiktok e Google</h3>
      </div>
    </div>
    <div class="wrapper-content-social-media" v-if="isShowCard">
      <div class="content-left-social-media">
        <div class="block-left-social-media">
          <Post
            :isSearching="isSearchingMedias"
            :medias="medias"
            :tiktokData="tiktokData"
            :days="this.activePill"
            :term="this.term.id"
            :mediaPagination="this.mediaPagination"
            @update:medias="(updatedMedias) => (medias = updatedMedias)"
          />
        </div>
        <div class="block-left-social-media">
          <DemographicMap
            :isSearching="isSearchingTouristSpots"
            :tourist_spots="tourist_spots"
            :days="this.activePill"
          />
        </div>
        <div class="block-left-social-media">
          <Event :isSearching="isSearchingEvents" :events="events" :days="this.activePill" />
        </div>
      </div>
      <div class="content-right-social-media">
        <div class="block-right-social-media">
          <TouristAttractions
            :isSearching="isSearchingTouristAttractions"
            :touristAttraction="touristAttraction"
          />
        </div>
        <div class="block-right-social-media">
          <CurrentTopics :isSearching="isSearchingTrends" :biggestTrends="biggestTrends" />
        </div>
        <div class="block-right-social-media">
          <Keywords
            :isSearching="isSearchingKeywords"
            :keyWords="keyWords"
            :days="this.activePill"
          />
        </div>
        <div class="block-right-social-media">
          <TopInfluencers :isSearching="isSearchingInfluencers" :topInfluencers="topInfluencers" />
        </div>
        <div class="block-right-social-media">
          <WordClouds
            :isSearching="isSearchingKeywords"
            :wordClouds="wordClouds"
            :days="this.activePill"
          />
        </div>
      </div>
    </div>
    <Toast position="top-center" />

    <SocialMediaInsights
      :termsSelect="termsSelect"
      :citiesString="citiesString"
      :roleIdProp="roleId"
      :termId="this.term && this.term.id"
      :states="states" 
      :socialMediaData="{
        value: this.term && this.term.id,
        days: this.activePill,
      }"
    />
  </div>
</template>

<script>
import WordClouds from './Components/WordClouds/WordClouds'
import TopInfluencers from './Components/TopInfluencers/TopInfluencers'
import Keywords from './Components/Keywords/Keywords'
import Event from './Components/Event/Event'
import DemographicMap from './Components/DemographicMap/DemographicMap'
import CurrentTopics from './Components/CurrentTopics/CurrentTopics'
import TouristAttractions from './Components/TouristAttractions/TouristAttractions'
import EngagementPerDay from './Components/Engagement/EngagementPerDay/EngagementPerDay'
import EngagementPerHour from './Components/Engagement/EngagementPerHour/EngagementPerHour'
import Post from './Components/Post/Post'
import Layout from './Components/Layout/Layout'
import SocialMediaInsights from './Components/Insights/SocialMediaInsights.vue'
import Button from '@/Shared/Button'
import LoadingButton from '@/Shared/LoadingButton'
import Multiselect from 'vue-multiselect'
import Toast from 'primevue/toast'
import axios from 'axios'
export default {
  components: {
    Multiselect,
    Button,
    LoadingButton,
    TouristAttractions,
    EngagementPerDay,
    EngagementPerHour,
    Post,
    CurrentTopics,
    DemographicMap,
    Keywords,
    TopInfluencers,
    WordClouds,
    Event,
    Toast,
    SocialMediaInsights,
  },
  layout: Layout,
  props: {
    user: Number,
    citiesString: String,
    roleId: Number,
  },
  computed: {
    socialMediaData() {
      return {
        value: term?.id || null,
        days: activePill,
      }
    },
  },

  data() {
    return {
      isLoadingSocialValues: false,
      isSearching: false,
      isSearchingMedias: false,
      isSearchingTouristAttractions: false,
      isSearchingTrends: false,
      isSearchingKeywords: false,
      isSearchingEvents: false,
      isSearchingInfluencers: false,
      isSearchingTouristSpots: false,
      isShowCard: false,
      styleLoadingButton: {
        style: 'height: 40px; padding: 0 30px',
        'margin-left': '10px',
        'font-family': 'Arial, sans-serif',
        'font-size': '14px',
        'font-weight': 600,
        padding: '10px 20px',
        color: '#fff',
        'background-color': '#64b4c8',
        border: 'none',
        'border-radius': '4px',
        cursor: 'pointer',
        display: 'inline-flex',
        'align-items': 'center',
        'justify-content': 'center',
        transition: 'background-color 0.3s',
      },
      termsSelect: [],
      states: [], 
      pillLabels: [
        { label: '7 dias', days: 7, enabled: true },
        { label: '30 dias', days: 30, enabled: true },
        { label: '3 meses', days: 90, enabled: true },
        { label: '1 ano', days: 364, enabled: true },
        { label: 'Todos', days: 0, enabled: true },
      ],
      term: null,
      activePill: 0,
      events: [],
      medias: [],
      tiktokData: [],
      mediaPagination: null,
      topInfluencers: [],
      wordClouds: [],
      keyWords: [],
      touristAttraction: [],
      biggestTrends: [],
      tourist_spots: [],
    }
  },
  mounted() {
    this.handleSocialValues()
  },
  watch: {
    // Quando os medias forem atualizados pelo componente pai (primeira carga)
    medias: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          // Se for a primeira carga, substitui os medias locais
          this.localMedias = [...newValue]
          // Emite evento para atualizar o estado no componente pai
          this.$emit('update:medias', this.localMedias)
        }
      },
    },
    days() {
      this.resetPagination()
    },

    // Quando o termo de busca mudar, reseta a paginação
    term() {
      this.resetPagination()
    },
  },
  methods: {
    handleFilterDays(days) {
      this.activePill = days
      this.handleSearch()
    },

    resetPagination() {
      this.nextCursor = null
      this.hasMorePages = true
      this.hasReachedEnd = false
    },
    async handleSearch() {
      if (!this.term.id) return

      try {
        this.isShowCard = true
        this.isSearchingMedias = true
        this.isSearchingTouristAttractions = true
        this.isSearchingTrends = true
        this.isSearchingKeywords = true
        this.isSearchingEvents = true
        this.isSearchingInfluencers = true
        this.isSearchingTouristSpots = true

        // Buscar mídias primeiro
        const mediasResponse = await axios.post('/api/social-media/search/medias', {
          value: this.term.id,
          days: this.activePill,
        })

        this.medias = mediasResponse.data.medias || []
        this.tiktokData = mediasResponse.data.tiktokData || []
        if (mediasResponse.data.pagination) {
          this.mediaPagination = mediasResponse.data.pagination
        }
        this.isSearchingMedias = false

        // Buscar atrações turísticas
        const attractionsResponse = await axios.post(
          '/api/social-media/search/tourist-attractions',
          {
            value: this.term.id,
            days: this.activePill,
          },
        )

        this.touristAttraction = attractionsResponse.data.touristAttraction
        this.isSearchingTouristAttractions = false

        // Buscar palavras-chave
        const keywordsResponse = await axios.post('/api/social-media/search/keywords', {
          value: this.term.id,
          days: this.activePill,
        })

        this.keyWords = keywordsResponse.data.keyWords
        this.wordClouds = keywordsResponse.data.wordClouds
        this.isSearchingKeywords = false

        // Buscar influencers
        const influencersResponse = await axios.post('/api/social-media/search/influencers', {
          value: this.term.id,
          days: this.activePill,
        })

        this.topInfluencers = influencersResponse.data.topInfluencers
        this.isSearchingInfluencers = false

        // Buscar eventos
        const eventsResponse = await axios.post('/api/social-media/search/events', {
          value: this.term.id,
          days: this.activePill,
        })

        this.events = eventsResponse.data.events
        this.isSearchingEvents = false

        // Buscar pontos turísticos
        const spotsResponse = await axios.post('/api/social-media/search/tourist-spots', {
          value: this.term.id,
          days: this.activePill,
        })

        this.tourist_spots = spotsResponse.data.tourist_spots
        this.isSearchingTouristSpots = false

        // Buscar tendências
        const trendsResponse = await axios.post('/api/social-media/search/trends', {
          value: this.term.id,
          days: this.activePill,
        })
        this.biggestTrends = trendsResponse.data.biggestTrends
        this.isSearchingTrends = false
      } catch (error) {
        console.log(error)
      } finally {
        this.isSearching = false
      }
    },
    async handleSocialValues() {
      try {
        this.isLoadingSocialValues = true
        const response = await axios.get(`/api/social-media/${this.user}`)
        this.termsSelect = response.data
        this.term = response.data[0] || {}
        if (!!this.term) {
          this.handleSearch()
        }
      } catch (error) {
        this.isLoadingSocialValues = false
        console.log(error)
      } finally {
        this.isLoadingSocialValues = false
      }
    },
    handleFilters() {
      // eslint-disable-next-line no-undef
      this.$inertia.visit(route('social.register'))
    },
  },
}
</script>

<style lang="scss" src="./styles.scss"></style>
